export const SLASH_COMMANDS = {
  inbox_write_for_me_v1: {
    labelKey: 'inlineAutocompleteMenu.draft.label',
    commandId: 'inbox_write_for_me_v1',
    id: 'write_for_me',
    headerKey: 'inlineAutocompleteMenu.draft.label',
    placeholder: 'inlineAutocompleteMenu.draft.placeholder'
  },
  // @TODO Update logic of plugin to handle direct insertion of summary, this is just a placeholder
  generate_summary: {
    labelKey: 'inlineAutocompleteMenu.summarizeConv.label',
    commandId: 'inbox_draft_message_v1',
    id: 'generate_summary',
    headerKey: 'inlineAutocompleteMenu.summarizeConv.label',
    placeholder: 'inlineAutocompleteMenu.summarizeConv.placeholder'
  }
};
export const SELECTION_COMMANDS = [{
  labelKey: 'inlineAutocompleteMenu.rewrite.label',
  commandId: 'playbook_inline_selection_commands_rewrite_v1',
  headerKey: 'inlineAutocompleteMenu.rewrite.label'
}, {
  labelKey: 'inlineAutocompleteMenu.expand.label',
  commandId: 'playbook_inline_selection_commands_expand_v1',
  headerKey: 'inlineAutocompleteMenu.expand.label'
}, {
  labelKey: 'inlineAutocompleteMenu.summarize.label',
  commandId: 'playbook_inline_selection_commands_summarize_v1',
  headerKey: 'inlineAutocompleteMenu.summarize.label'
}, {
  labelKey: 'inlineAutocompleteMenu.changeTone.label',
  commandId: 'playbook_inline_selection_commands_change_tone_v1',
  headerKey: 'inlineAutocompleteMenu.changeTone.label',
  subMenu: [{
    labelKey: 'inlineAutocompleteMenu.changeTone.professional.label',
    headerKey: 'inlineAutocompleteMenu.changeTone.professional.label',
    parameters: {
      toneOfVoice: 'professional'
    }
  }, {
    labelKey: 'inlineAutocompleteMenu.changeTone.educational.label',
    headerKey: 'inlineAutocompleteMenu.changeTone.educational.label',
    parameters: {
      toneOfVoice: 'educational'
    }
  }, {
    labelKey: 'inlineAutocompleteMenu.changeTone.witty.label',
    headerKey: 'inlineAutocompleteMenu.changeTone.witty.label',
    parameters: {
      toneOfVoice: 'witty'
    }
  }, {
    labelKey: 'inlineAutocompleteMenu.changeTone.authoritative.label',
    headerKey: 'inlineAutocompleteMenu.changeTone.authoritative.label',
    parameters: {
      toneOfVoice: 'authoritative'
    }
  }]
}];